function WalletIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12.6187"
        r="10"
        className="stroke"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M12 17.6187V18.1187V18.6187"
        stroke="black"
        className="stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 6.61865V7.11865V7.61865"
        stroke="black"
        className="stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 10.1187C15 8.73794 13.6569 7.61865 12 7.61865C10.3431 7.61865 9 8.73794 9 10.1187C9 11.4994 10.3431 12.6187 12 12.6187C13.6569 12.6187 15 13.7379 15 15.1187C15 16.4994 13.6569 17.6187 12 17.6187C10.3431 17.6187 9 16.4994 9 15.1187"
        stroke="black"
        className="stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default WalletIcon;
